import { ATTR_NAME } from 'constants/attr-name'
import { Nullable } from 'constants/types'

/**
 * Referenced (page) types defined here. (Minimizes bundle size.)
 */
export enum PageType {
    index = 'index',
    category = 'category',
    story = 'story',
    search = 'search',
    videoCentre = 'video-centre',
    documentation = 'documentation',
    partnerships = 'partnerships',
    staticform = 'staticform',
    newsletters = 'newsletters'
}

/**
 * DOM related helper functions.
 */
export class Page {
    /**
     * Get the page type of the current page, default to index
     */
    static get type(): PageType {
        const htmlElem = document.querySelector<HTMLElement>('html')
        let type: Nullable<string> = ''
        if (htmlElem) {
            type = htmlElem.getAttribute(`${ATTR_NAME.page.pageType}`)
        }
        return PageType[type as keyof typeof PageType] || PageType.index
    }
}
